import React from "react"
import { Helmet } from 'react-helmet'

const GoogleAd = ({ slot }) => {
  return (
    <>
      <Helmet>
        <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4528415803965338" crossOrigin="anonymous"></script>
      </Helmet>
      <ins 
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client="ca-pub-4528415803965338"
        data-ad-slot={slot}
        data-ad-format="auto"
        data-full-width-responsive="true">
      </ins>
      <script dangerouslySetInnerHTML={{ __html: "(adsbygoogle = window.adsbygoogle || []).push({});" }} />
    </>
  )
}

export default GoogleAd;
